/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { CashBoxDetailsDto } from '../../api/cashBoxes/cashBoxesClient.typings';
import { EntirePeriodTurnover } from '../../api/apiCommon.typings';
import { CashBoxDetailsAction, CashBoxDetailsActionType } from '../../actions/CashBoxRegistry/cashBoxDetailsActions';
import {
    collapseEntirePeriodTurnovers,
    expandTurnoversPeriod,
    updateEntirePeriodTurnoverWithNewData,
} from '../../../components/RegistryWidgets/Common/TurnoversUtils';
import moment from 'moment';

export const turnoversRowsPerPage = [20, 30, 40];
export const defaultTurnoversPaginationLimit = turnoversRowsPerPage[0];
export const historyRowsPerPage = [15, 20, 25, 30];
export const defaultHistoryPaginationLimit = historyRowsPerPage[0];
export const today = moment().startOf('day');

export interface CashBoxDetailsState {
    cashboxTaxNumber: string;
    cashboxDetails: CashBoxDetailsDto;
    isLoading: boolean;
    currentHistoryTab: number;

    cashBoxTurnoversByPeriod: EntirePeriodTurnover;
    isLoadingTurnovers: boolean;
    isTurnoversTableHidden: boolean;
}

const initialState: CashBoxDetailsState = {
    cashboxTaxNumber: null,
    cashboxDetails: null,
    isLoading: false,
    currentHistoryTab: 0,

    cashBoxTurnoversByPeriod: null,
    isLoadingTurnovers: false,
    isTurnoversTableHidden: true,
};

export function cashBoxDetailsReducer(
    state: CashBoxDetailsState = initialState,
    action: CashBoxDetailsAction,
): CashBoxDetailsState {
    switch (action.type) {
        case CashBoxDetailsActionType.OPEN_REGISTRY_CASHBOX_CARD_PAGE:
            const previousTaxNumber = state.cashboxTaxNumber;
            const currentTaxNumber = action.payload;

            let isNewCardOpen = true;
            if (previousTaxNumber && currentTaxNumber) isNewCardOpen = previousTaxNumber !== currentTaxNumber;

            return {
                ...state,
                isLoading: true,
                cashboxTaxNumber: action.payload,
                cashBoxTurnoversByPeriod:
                    isNewCardOpen || !state.cashBoxTurnoversByPeriod ? null : { ...state.cashBoxTurnoversByPeriod },
                isTurnoversTableHidden: isNewCardOpen
                    ? initialState.isTurnoversTableHidden
                    : state.isTurnoversTableHidden,
            };

        case CashBoxDetailsActionType.FETCH_CASHBOX_DETAILS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                cashboxDetails: action.payload,
            };

        case CashBoxDetailsActionType.CASHBOX_DETAILS_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case CashBoxDetailsActionType.CHANGE_HISTORY_TAB:
            return {
                ...state,
                currentHistoryTab: action.payload,
            };

        case CashBoxDetailsActionType.FETCH_CASHBOX_TURNOVERS:
            return {
                ...state,
                isLoadingTurnovers: true,
            };

        case CashBoxDetailsActionType.FETCH_CASHBOX_TURNOVERS_SUCCESS:
            return {
                ...state,
                isLoadingTurnovers: false,
                cashBoxTurnoversByPeriod: updateEntirePeriodTurnoverWithNewData(
                    state.cashBoxTurnoversByPeriod,
                    action.payload,
                ),
            };

        case CashBoxDetailsActionType.FETCH_CASHBOX_TURNOVERS_ERROR:
            return {
                ...state,
                isLoadingTurnovers: false,
            };

        case CashBoxDetailsActionType.SET_TURNOVERS_HIDE_TOGGLE:
            return {
                ...state,
                isTurnoversTableHidden: action.payload,
            };

        case CashBoxDetailsActionType.COLLAPSE_TURNOVERS:
            return {
                ...state,
                cashBoxTurnoversByPeriod: collapseEntirePeriodTurnovers(state.cashBoxTurnoversByPeriod),
            };

        case CashBoxDetailsActionType.EXPAND_TURNOVERS_PERIOD:
            return {
                ...state,
                cashBoxTurnoversByPeriod: expandTurnoversPeriod(
                    state.cashBoxTurnoversByPeriod,
                    action.payload.period,
                    action.payload.isToHide,
                ),
            };

        case CashBoxDetailsActionType.DOWNLOAD_TURNOVERS:
            return {
                ...state,
                isLoadingTurnovers: true,
            };

        case CashBoxDetailsActionType.DOWNLOAD_TURNOVERS_SUCCESS:
        case CashBoxDetailsActionType.DOWNLOAD_TURNOVERS_ERROR:
            return {
                ...state,
                isLoadingTurnovers: false,
            };

        case CashBoxDetailsActionType.EXIT_REGISTRY_CASHBOX_CARD_PAGE:
            return {
                ...state,
                cashboxDetails: null,
                currentHistoryTab: 0,
            };

        default:
            break;
    }
    return state;
}
